import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import dispatcher from 'mewe/dispatcher';
import AccountApi from 'mewe/api/account-api';
import { processCloudStorageData } from 'mewe/utils/miscellaneous-utils';
import { ds } from 'mewe/stores/ds';
import './styles.scss';

export default class MwMainHeaderDropdown extends Component {
  @service router;
  @service account;
  @service analytics;
  @service features;

  @tracked cloudStorageInfo;
  @tracked questState = ds.questState;

  constructor() {
    super(...arguments);
    this.fetchAndSetUsedSpaceDetails();
  }

  get storageTooltipText() {
    if (!this.cloudStorageInfo) {
      return '';
    }

    return __('{spaceAmount}GB / {spaceTotalAmount}GB', {
      spaceAmount: this.cloudStorageInfo.usedGB,
      spaceTotalAmount: this.cloudStorageInfo.totalGB,
    });
  }

  get showQuestLink() {
    return this.features.isEnabled('web_is_gamification_enabled') && this.questState?.isLoaded;
  }

  // could be optimized to avoid fetching on each opening but store the data somewhere
  fetchAndSetUsedSpaceDetails() {
    AccountApi.getSpaceUsedStatus(false).then((data) => {
      if (this.isDestroyed || this.isDestroying) return;
      this.cloudStorageInfo = processCloudStorageData(data);
    });
  }

  @action
  logout() {
    dispatcher.dispatch('app', 'logout');
  }

  @action
  openFeedback() {
    dispatcher.dispatch('feedback', 'openFeedbackDialog');
  }

  @action
  helpCenterClicked() {
    this.analytics.sendEvent('buttonClicked', 'Help Center');
  }
}
